module.exports = __webpack_public_path__ + "img/synapse-homepage.59f3c6d0.webp";